import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../../features/Header"; 


interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const location = useLocation();

  const fullScreenRoutes = ["/login", "/signup"];

  const isFullScreen = fullScreenRoutes.includes(location.pathname);

  return (
    <>
      {!isFullScreen && <Header />}
      <div style={{ display: "flex" }}>
        <main style={{ width: "100vw", height: "100vh" }}>
          {children}
        </main>
      </div>
    </>
  );
};

export default AppLayout;
